// ============================================================================
// Sidebar v2 — menú lateral común de la suite Dimo.
//
// Es el `Sidebar` de la app SEO/GEO con dos cosas nuevas:
//   · se pliega a 64 px (solo iconos) y recuerda el estado en localStorage
//   · se pliega solo por debajo de 1100 px de ancho
//
// Se alimenta por props para que la lista de secciones viva en la app y no
// aquí dentro. Así el día que la cáscara quiera pintar el menú de todas las
// apps (la "opción B" del plan) solo cambia quién le pasa las props.
// ============================================================================
import { useEffect, useState } from "react";
import { C, GRAD } from "./theme.js";
import Marca from "./Marca.jsx";

// Iconos SVG en línea (trazo, estilo lucide) — sin dependencias.
export const ICONOS = {
  dashboard: <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" fill="currentColor" stroke="none" />,
  resumen: <><path d="M3 3v18h18" /><path d="M7 15v-4" /><path d="M12 15V7" /><path d="M17 15v-6" /></>,
  seo: <><circle cx="11" cy="11" r="7" /><path d="m21 21-4.35-4.35" /></>,
  trafico: <><path d="M3 3v18h18" /><path d="m7 15 4-6 4 3 5-8" /></>,
  marketing: <><path d="m3 11 18-7-7 18-2.5-7.5L3 11z" /></>,
  workflows: <><rect x="5" y="8" width="14" height="11" rx="2" /><path d="M12 8V5" /><circle cx="12" cy="3.5" r="1.2" /><path d="M9 13h.01" /><path d="M15 13h.01" /><path d="M9.5 16h5" /></>,
  historial: <><path d="M3 12a9 9 0 1 0 3-6.7" /><path d="M3 4v5h5" /><path d="M12 7.5V12l3 2" /></>,
  local: <><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" /><circle cx="12" cy="10" r="3" /></>,
  inventario: <><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H8c-.6 0-1.1.2-1.4.7L4.6 10.3C3.7 10.5 3 11.3 3 12.2V16c0 .6.4 1 1 1h2" /><circle cx="7" cy="17" r="2" /><circle cx="17" cy="17" r="2" /></>,
  // ── CRM ──
  entrada: <><path d="M4 6h16v12H4z" /><path d="m4 7 8 6 8-6" /></>,
  email: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></>,
  customer: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
  meta: <><path d="M4 15c0-5 2.5-8 5-8 3 0 4 3 6 6s3 5 5 5c1.7 0 2-1.6 2-3 0-4-2.5-8-5-8-3 0-4.5 3-6.5 6.5S7.5 20 5.5 20C3.8 20 3 18.4 3 17" /></>,
  auto: <><path d="M12 3v3" /><rect x="4" y="6" width="16" height="12" rx="2" /><path d="M9 12h.01" /><path d="M15 12h.01" /><path d="M9.5 15.5h5" /></>,
  callcenter: <><path d="M4 9a8 8 0 0 1 16 0" /><path d="M4 13v-2a2 2 0 0 1 2-2h1v6H6a2 2 0 0 1-2-2z" /><path d="M20 13v-2a2 2 0 0 0-2-2h-1v6h1a2 2 0 0 0 2-2z" /><path d="M17 15v2a3 3 0 0 1-3 3h-2" /></>,
  admin: <><path d="M12 3 4 6.5v5c0 5 3.4 8.6 8 9.5 4.6-.9 8-4.5 8-9.5v-5L12 3z" /><path d="m9 12 2 2 4-4" /></>,
  comerciales: <><circle cx="9" cy="8" r="3" /><path d="M3 20a6 6 0 0 1 12 0" /><circle cx="17" cy="9" r="2.5" /><path d="M21 19a4.5 4.5 0 0 0-5-4.4" /></>,
  drive: <><path d="M4 7a2 2 0 0 1 2-2h4l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" /></>,
  costes: <><circle cx="12" cy="12" r="9" /><path d="M12 7v10" /><path d="M15 9.5c0-1.4-1.3-2.2-3-2.2s-3 .8-3 2.2c0 3 6 1.5 6 4.6 0 1.4-1.3 2.2-3 2.2s-3-.8-3-2.2" /></>,
  brain: <><path d="M9.5 4.5A2.8 2.8 0 0 0 6.8 7a2.6 2.6 0 0 0-1.6 4.4A2.7 2.7 0 0 0 6.4 15.6a2.7 2.7 0 0 0 3.1 3.6V4.5z" /><path d="M14.5 4.5A2.8 2.8 0 0 1 17.2 7a2.6 2.6 0 0 1 1.6 4.4 2.7 2.7 0 0 1-1.2 4.2 2.7 2.7 0 0 1-3.1 3.6V4.5z" /><path d="M12 4.2v15.6" /></>,
  centro: <><rect x="3" y="3" width="7" height="7" rx="1.6" /><rect x="14" y="3" width="7" height="7" rx="1.6" /><rect x="3" y="14" width="7" height="7" rx="1.6" /><rect x="14" y="14" width="7" height="7" rx="1.6" /></>,
};

export function NavIcon({ name, size = 17 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      {ICONOS[name] || ICONOS.dashboard}
    </svg>
  );
}

const ANCHO = 234;
const ANCHO_MIN = 64;

// ── Desglose de una sección. Si los sub-items llevan `grupo`, cada grupo es un
// acordeón que se pliega y despliega al clicar su cabecera. ────────────────
function SubMenu({ sec, subItems, activeId, onSelectSub }) {
  const grupoActivo = subItems.find((t) => t.id === activeId)?.grupo || null;
  const [abiertos, setAbiertos] = useState(() => new Set(grupoActivo ? [grupoActivo] : []));
  useEffect(() => {
    if (grupoActivo) setAbiertos((s) => (s.has(grupoActivo) ? s : new Set(s).add(grupoActivo)));
  }, [grupoActivo]);
  const toggle = (g) => setAbiertos((s) => { const n = new Set(s); n.has(g) ? n.delete(g) : n.add(g); return n; });

  const boton = (t) => {
    const onSub = activeId === t.id;
    return (
      <button key={t.id} onClick={() => onSelectSub && onSelectSub(sec, t.id)} className="fg-nav" style={{
        display: "flex", alignItems: "center", gap: 8, width: "100%", textAlign: "left",
        padding: "7px 10px", marginBottom: 1, borderRadius: 8, border: "none", cursor: "pointer",
        fontSize: 12, fontWeight: 700, fontFamily: "inherit",
        background: onSub ? "#eaf3f9" : "transparent", color: onSub ? C.brand : C.muted,
      }}>
        <span style={{ flex: 1 }}>{t.label}</span>
        {t.badge != null && t.badge > 0 && (
          <span style={{
            fontSize: 9.5, fontWeight: 800, minWidth: 17, height: 16, padding: "0 5px", borderRadius: 999,
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            background: onSub ? C.brand : "#e7ebef", color: onSub ? "#fff" : C.muted,
          }}>{t.badge > 99 ? "99+" : t.badge}</span>
        )}
      </button>
    );
  };

  const sueltos = subItems.filter((t) => !t.grupo);
  const grupos = [];
  for (const t of subItems) {
    if (!t.grupo) continue;
    let g = grupos.find((x) => x.nombre === t.grupo);
    if (!g) { g = { nombre: t.grupo, items: [] }; grupos.push(g); }
    g.items.push(t);
  }

  return (
    <div className="fg-fade" style={{ margin: "1px 0 7px 19px", paddingLeft: 11, borderLeft: `2px solid ${C.line}` }}>
      {sueltos.map(boton)}
      {grupos.map((g) => {
        const abierto = abiertos.has(g.nombre);
        const tieneActivo = g.items.some((t) => t.id === activeId);
        return (
          <div key={g.nombre}>
            <button onClick={() => toggle(g.nombre)} className="fg-nav" title={abierto ? "Plegar" : "Desplegar"} style={{
              display: "flex", alignItems: "center", gap: 6, width: "100%", textAlign: "left",
              padding: "6px 10px", marginBottom: 1, borderRadius: 8, border: "none", cursor: "pointer",
              fontSize: 10, fontWeight: 800, letterSpacing: 0.9, textTransform: "uppercase", fontFamily: "inherit",
              background: "transparent", color: tieneActivo ? C.brand : C.faint,
            }}>
              <span style={{ fontSize: 8, display: "inline-block", transform: abierto ? "rotate(90deg)" : "none", transition: "transform .15s" }}>▶</span>
              {g.nombre}
            </button>
            {abierto && <div className="fg-fade">{g.items.map(boton)}</div>}
          </div>
        );
      })}
    </div>
  );
}

// Rotulillo de sección del menú («ENTRADA DE LEADS», «ANALÍTICA»…).
function TituloGrupo({ children, primero }) {
  return (
    <div style={{
      fontSize: 10, fontWeight: 800, letterSpacing: 1.2, color: C.faint, textTransform: "uppercase",
      padding: primero ? "8px 10px 6px" : "16px 10px 6px", whiteSpace: "nowrap", overflow: "hidden",
    }}>{children}</div>
  );
}

// Botón de plegado, en la propia cabecera del menú.
function BotonPlegar({ colapsado, onClick }) {
  return (
    <button onClick={onClick} className="fg-nav"
      title={colapsado ? "Desplegar el menú" : "Plegar el menú"}
      aria-label={colapsado ? "Desplegar el menú" : "Plegar el menú"}
      style={{
        width: 26, height: 26, borderRadius: 8, border: `1px solid ${C.line}`, background: "#fff",
        color: C.muted, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
        flexShrink: 0, padding: 0,
      }}>
      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
        style={{ transform: colapsado ? "rotate(180deg)" : "none", transition: "transform .18s ease" }}>
        <path d="m14 6-6 6 6 6" />
      </svg>
    </button>
  );
}

export default function Sidebar({
  sections, active, onSelect,
  subs = {}, subActive = {}, onSelectSub = null,
  dots = {}, badges = {},
  userEmail, userNombre, onLogout,
  updatedAt, loading, onRefresh,
  orgDark, onToggleDark, showDark = false,
  pie = null,
  marca = true,
  claveMemoria = "dimo-sidebar-colapsado",
}) {
  // Estado de plegado: lo que el usuario eligió manda, y si no ha elegido
  // nada se pliega solo en pantallas estrechas.
  const [colapsado, setColapsado] = useState(() => {
    try {
      const guardado = window.localStorage.getItem(claveMemoria);
      if (guardado === "1") return true;
      if (guardado === "0") return false;
    } catch (e) { /* modo privado: sin memoria, no pasa nada */ }
    return typeof window !== "undefined" && window.innerWidth < 1100;
  });

  useEffect(() => {
    let manual = null;
    try { manual = window.localStorage.getItem(claveMemoria); } catch (e) {}
    if (manual === "0" || manual === "1") return; // el usuario ya decidió
    const alRedimensionar = () => setColapsado(window.innerWidth < 1100);
    window.addEventListener("resize", alRedimensionar);
    return () => window.removeEventListener("resize", alRedimensionar);
  }, [claveMemoria]);

  const alternar = () => {
    setColapsado((v) => {
      const siguiente = !v;
      try { window.localStorage.setItem(claveMemoria, siguiente ? "1" : "0"); } catch (e) {}
      return siguiente;
    });
  };

  const portada = sections.filter((s) => !s.grupo);
  const agrupadas = sections.filter((s) => s.grupo);

  const Entrada = (s) => {
    const on = active === s.id;
    const dot = dots[s.id];              // 'ok' | 'wait' | undefined
    const badge = badges[s.id];          // número (leads pendientes, etc.)
    const subItems = subs[s.id];
    const conSub = subItems && subItems.length > 0;

    // Plegado: al pulsar una sección con desglose, el menú se abre para que se
    // vea el desglose. Es lo menos sorprendente y evita menús flotantes.
    const alPulsar = () => {
      if (colapsado && conSub) alternar();
      onSelect(s.id);
    };

    return (
      <div key={s.id}>
        <button onClick={alPulsar} className="fg-nav" title={colapsado ? s.label : undefined} style={{
          display: "flex", alignItems: "center", gap: colapsado ? 0 : 10, width: "100%",
          justifyContent: colapsado ? "center" : "flex-start", textAlign: "left",
          padding: colapsado ? "11px 0" : "10px 12px", marginBottom: 3, borderRadius: 10,
          cursor: "pointer", border: "none", fontSize: 13, fontWeight: 700, letterSpacing: 0.1,
          fontFamily: "inherit", position: "relative",
          background: on ? GRAD : "transparent",
          color: on ? "#fff" : C.page,
          boxShadow: on ? "0 6px 16px rgba(0,81,135,.28)" : "none",
        }}>
          <NavIcon name={s.icon} />
          {!colapsado && <span style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{s.label}</span>}
          {!colapsado && badge != null && badge > 0 && (
            <span style={{
              fontSize: 9.5, fontWeight: 800, minWidth: 18, height: 17, padding: "0 5px", borderRadius: 999,
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              background: on ? "rgba(255,255,255,.24)" : `${C.brand}14`, color: on ? "#fff" : C.brand,
            }}>{badge > 99 ? "99+" : badge}</span>
          )}
          {!colapsado && conSub && <span style={{ fontSize: 9, opacity: 0.85 }}>{on ? "▾" : "▸"}</span>}
          {dot && (
            <span title={dot === "ok" ? "Con datos" : "En espera de datos"} style={{
              width: 7, height: 7, borderRadius: "50%",
              background: on ? "#fff" : dot === "ok" ? C.verde : C.gris,
              opacity: on ? 0.9 : 1,
              ...(colapsado ? { position: "absolute", top: 7, right: 9 } : null),
            }} />
          )}
          {colapsado && badge != null && badge > 0 && (
            <span style={{
              position: "absolute", top: 4, right: 6, minWidth: 15, height: 15, padding: "0 4px",
              borderRadius: 999, fontSize: 9, fontWeight: 800, display: "flex", alignItems: "center",
              justifyContent: "center", background: on ? "#fff" : C.brand, color: on ? C.brand : "#fff",
            }}>{badge > 99 ? "99+" : badge}</span>
          )}
        </button>
        {conSub && on && !colapsado && (
          <SubMenu sec={s.id} subItems={subItems} activeId={subActive[s.id]} onSelectSub={onSelectSub} />
        )}
      </div>
    );
  };

  let grupoPintado = null;
  const inicial = (userNombre || userEmail || "?").trim()[0]?.toUpperCase() || "?";

  return (
    <aside style={{
      width: colapsado ? ANCHO_MIN : ANCHO, flexShrink: 0, background: "#fff",
      borderRight: `1px solid ${C.line}`, display: "flex", flexDirection: "column",
      position: "sticky", top: 0, height: "100vh", transition: "width .18s ease", overflow: "hidden",
    }}>
      {/* Cabecera: logotipo + botón de plegado */}
      <div style={{
        padding: colapsado ? "16px 0 0" : marca ? "20px 16px 0" : "14px 16px 0", display: "flex", alignItems: "center",
        justifyContent: colapsado || !marca ? "center" : "space-between", gap: 8,
      }}>
        {colapsado || !marca ? <BotonPlegar colapsado={colapsado} onClick={alternar} /> : (
          <>
            <Marca height={38} />
            <BotonPlegar colapsado={false} onClick={alternar} />
          </>
        )}
      </div>

      {portada.length > 0 && (
        <div style={{ padding: colapsado ? "12px 8px 0" : "12px 12px 0" }}>{portada.map(Entrada)}</div>
      )}

      <div style={{ padding: colapsado ? "0 8px 6px" : "0 12px 6px", flex: 1, overflowY: "auto", overflowX: "hidden" }}>
        {agrupadas.map((s) => {
          const nuevo = s.grupo !== grupoPintado;
          const primero = grupoPintado === null;
          if (nuevo) grupoPintado = s.grupo;
          return (
            <div key={s.id}>
              {nuevo && (colapsado
                ? <div style={{ height: 1, background: C.line, margin: "10px 6px 8px" }} />
                : <TituloGrupo primero={primero}>{s.grupo}</TituloGrupo>)}
              {Entrada(s)}
            </div>
          );
        })}
      </div>

      {/* Pie */}
      <div style={{ padding: colapsado ? "12px 8px 14px" : "14px 16px 16px", borderTop: `1px solid ${C.line}` }}>
        {pie}

        {(updatedAt || onRefresh) && (
          <div style={{ marginBottom: 12 }}>
            {updatedAt && !colapsado && (
              <div style={{ fontSize: 10.5, color: C.faint, marginBottom: 7 }}>
                actualizado {updatedAt.toLocaleTimeString("es-ES", { hour: "2-digit", minute: "2-digit" })}
              </div>
            )}
            <div style={{ display: "flex", gap: 8, flexDirection: colapsado ? "column" : "row" }}>
              {showDark && (
                <button onClick={onToggleDark} title="Tema oscuro del organigrama" style={{
                  flex: 1, fontSize: 11.5, fontWeight: 700, padding: "7px 0", borderRadius: 8, cursor: "pointer",
                  fontFamily: "inherit", border: `1px solid ${orgDark ? C.ink : C.line}`,
                  background: orgDark ? C.ink : "#fff", color: orgDark ? "#fff" : C.page,
                }}>{colapsado ? "🌙" : "🌙 Dark"}</button>
              )}
              {onRefresh && (
                <button onClick={onRefresh} disabled={loading} title="Actualizar datos" style={{
                  flex: 1, fontSize: 11.5, fontWeight: 700, padding: colapsado ? "8px 0" : "7px 0",
                  borderRadius: 8, cursor: loading ? "default" : "pointer", fontFamily: "inherit",
                  border: `1px solid ${C.line}`, background: "#fff", color: C.page, opacity: loading ? 0.6 : 1,
                }}>{colapsado ? "↻" : "↻ Actualizar"}</button>
              )}
            </div>
          </div>
        )}

        {(userEmail || userNombre) && (
          <div style={{
            display: "flex", alignItems: "center", gap: 9, marginBottom: 10,
            justifyContent: colapsado ? "center" : "flex-start",
          }} title={colapsado ? (userNombre || userEmail) : undefined}>
            <div style={{
              width: 30, height: 30, borderRadius: "50%", background: GRAD, color: "#fff",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 12.5, fontWeight: 800, flexShrink: 0,
            }}>{inicial}</div>
            {!colapsado && (
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 11.5, fontWeight: 700, color: C.ink, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {userNombre || userEmail}
                </div>
                <div style={{ fontSize: 10, color: C.faint }}>Grupo Dimoauto</div>
              </div>
            )}
          </div>
        )}

        {onLogout && (
          <button onClick={onLogout} title="Cerrar sesión" style={{
            width: "100%", fontSize: 11.5, fontWeight: 700, color: C.page, cursor: "pointer",
            border: `1px solid ${C.line}`, borderRadius: 8, padding: "7px 0", background: "#fff",
            fontFamily: "inherit",
          }}>{colapsado ? "⏻" : "Salir"}</button>
        )}
      </div>
    </aside>
  );
}
